/*
* Achtung: bei der Konfiguration von "stackto" muss man mit den Gruppen aufpassen - nicht alles stacked immer perfekt :)
*/
mp.sticky = {
    groups: {},
    el: [],

    init: function () {
        $('.mpSticky')
            .removeClass('mpSticky')
            .css('top', 'unset')
            .css('width', 'auto');
        $('.mpGhost').remove();
        mp.sticky.el = [];

        $('[data-sticky]').each(function (k, v) {
            var item = {
                'key': 'mpU' + Math.floor(Math.random() * 10000),
                'ref': $(v),
                'group': 'noGroup',
                'stackto': '',
                'container': null,
                'watchNav': null
            };
            $('<div id="' + item.key + '" class="mpGhost"></div>').insertBefore(item.ref); // mpGhost ist der Höhenplatzhalter
            item.ghost = $('#' + item.key);

            if (typeof (item.ref.data('sticky-group')) !== 'undefined') {
                item.group = item.ref.data('sticky-group');
            }
            mp.sticky.groups[item.group] = 0;

            if (typeof (item.ref.data('sticky-stackto')) !== 'undefined') {
                item.stackto = item.ref.data('sticky-stackto');
            }

            if (typeof (item.ref.data('sticky-container')) !== 'undefined') {
                item.container = $(item.ref.data('sticky-container'));
            }

            if (typeof (item.ref.data('sticky-watchnav')) !== 'undefined') { // Markierung aktiver Zustände (ähnlich dem Scrollspy)
                item.watchNav = {
                    'active': 0,
                    'nav': [],
                    'el': []
                };

                item.ref.find('a').each(function (k, v) {
                    var ref = $(this).attr('href');
                    if ($(ref).length === 1) {
                        $(this).on('click', function (ev) {
                            ev.preventDefault();

                            var fixedHeaderStart = mp.sticky.groups.topnav; // FIXME
                            var ref = $(this).attr('href');
                            var refHL = $(ref).find('.mcHeadline').first();
                            var $scrollDest = function () {
                                var tmp = $(ref).offset().top - (item.ref.outerHeight() + mp.sticky.groups.topnav) + 1;
                                if (refHL.length == 1) {
                                    tmp += $(refHL).outerHeight(true);
                                }
                                return tmp;
                            };

                            $('html, body').stop().animate(
                                {
                                    scrollTop: $scrollDest()
                                },
                                {
                                    duration: 500,
                                    step: function (now, fx) {
                                        // sofern es beim Scrolling eine Änderung des fixedheader gab, wird das Ende der Animation neu berechnet
                                        if (fixedHeaderStart != mp.sticky.groups.topnav) { // FIXME
                                            fx.start = now;
                                            fx.end = $scrollDest();
                                        }
                                    }
                                }
                            );
                            return false;
                        });

                        item.watchNav.nav.push($(this).parent()); // gleich der li des nav-Elements
                        item.watchNav.el.push($(ref)); // der Inhaltsabschnitt
                    }
                });
            }

            // alle unsere Items zur Überwachung
            mp.sticky.el.push(item);
        });

        mp.sticky.scroll();

        return;
    },
    scroll: function () {
        var scrollTop = ($(window).scrollTop() <= 0 ? 0 : $(window).scrollTop()); // negativ-Check wg. iOS-Safari
        if (scrollTop == 0 && !$('body').hasClass('scroll-top')) {
            $('body').addClass('scroll-top');
        } else if (scrollTop > 0 && $('body').hasClass('scroll-top')) {
            $('body').removeClass('scroll-top');
        }

        if (mp.sticky.el.length > 0) {
            var i = 0;
            mp.sticky.el.forEach(function (item) {
                mp.sticky.updateGroupsFixedHeight();
                var ghostTop = mp.sticky.getGroupGhostTop(item.group);
                var groupFixedHeight = (item.stackto != '' ? mp.sticky.groups[item.stackto] : 0); // FIXME: die Logik reicht nimmer, wenn man mehrere stackto hat

                if ((ghostTop - scrollTop - groupFixedHeight) <= 0) {
                    if (item.ref.hasClass('mpSticky') === false) {
                        item.ghost.css('height', (item.ref.is(':visible') ? item.ref.outerHeight(true) : 0));

                        item.ref
                            .addClass('mpSticky')
                            .css('top', (item.stackto != '' ? mp.sticky.groups[item.stackto] : mp.sticky.groups[item.group]))
                            .css('z-index', 100 - i);

                        $('body').addClass('has-fixed-' + item.group);

                        if (item.container) {
                            item.ref.css('width', item.container.innerWidth());
                        } else {
                            item.ref.css('width', item.ref.parents('.container').innerWidth());
                        }
                    } else if (item.container) {
                        // Achtung: rechenintensiv
                        var containerBottom = item.container.outerHeight(true) + item.container.offset().top + (typeof (item.container.position()) != 'undefined' ? item.container.position().top : 0);
                        var scrollPosition = scrollTop + groupFixedHeight + item.ref.outerHeight();

                        if (scrollPosition > containerBottom) {
                            item.ref.css('top', groupFixedHeight - (scrollPosition - containerBottom));
                        } else {
                            item.ref.css('top', groupFixedHeight);
                        }
                    }
                    item.ghost.css('height', (item.ref.is(':visible') ? item.ref.outerHeight(true) : 0)); // Korrekturlauf wg. container-Anpassung

                    // Navigation als active markieren
                    if (item.watchNav) {
                        var last = 0;
                        var refHeight = item.ref.outerHeight() + groupFixedHeight;
                        item.watchNav.el.forEach(function (el, key) {
                            if ((el.offset().top - scrollTop) <= refHeight) {
                                last = key;
                            }
                        });

                        if (last != item.watchNav.active) {
                            item.watchNav.active = last;
                            item.watchNav.nav.forEach(function (el, key) {
                                if (item.watchNav.active === key) {
                                    el.addClass('active');
                                } else {
                                    el.removeClass('active');
                                }
                            });
                        }
                    }
                } else if (item.ref.hasClass('mpSticky') === true) {
                    item.ref
                        .removeClass('mpSticky')
                        .css('top', 'unset')
                        .css('width', 'auto');
                    item.ghost.css('height', 0);
                    $('body').removeClass('has-fixed-' + item.group);
                }

                i++;
            });
        }
        return;
    },
    updateGroupsFixedHeight: function () {
        for (var i in mp.sticky.groups) {
            mp.sticky.groups[i] = 0;
        }

        mp.sticky.el.forEach(function (item) {
            if (item.ref.hasClass('mpSticky') === true && item.ref.is(':visible')) {
                mp.sticky.groups[item.group] += item.ref.outerHeight(true);
                if (item.stackto != '') {
                    var pos = item.ref.position();
                    mp.sticky.groups[item.group] += pos.top;
                }
            }
        });

        return;
    },
    getGroupGhostTop: function (group) {
        var val = null;
        var elHeights = 0;

        mp.sticky.el.forEach(function (item) {
            if (item.group === group) {
                var pos = item.ghost.offset();
                if (val == null) {
                    val = pos.top;
                }
            }
        });

        if (val == null) {
            val = 0;
        }

        return val;
    }
};

$(document).ready(function () {
    mp.sticky.init();

    $(window).on('resize', mp.sticky.init);
    $(window).on('scroll', mp.sticky.scroll);
    $('#mpEvent').on('contentxhr', mp.sticky.init);
});
